import { Template, UserOverrides } from './resumeTypes';

export const getLuminance = (hex: string): number => {
  const rgb = hex.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
  if (!rgb) return 128;
  const r = parseInt(rgb[1], 16);
  const g = parseInt(rgb[2], 16);
  const b = parseInt(rgb[3], 16);
  return (0.299 * r + 0.587 * g + 0.114 * b);
};

export const getTextColorForBackground = (bg: string): string =>
  getLuminance(bg) > 128 ? '#303030' : '#FFFFFF';

export const formatDate = (dateStr: string): string => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const [year, month] = dateStr.trim().split('-');
  if (!year) return '';
  const names = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  const monthNum = month != null && month !== '' ? parseInt(month, 10) : NaN;
  const monthName = !isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 ? names[monthNum - 1] : '';
  return monthName ? `${monthName} ${year}` : year;
};

export const formatBirthDate = (dateStr: string): string => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const [y, m, day] = dateStr.trim().split('-');
  if (!y) return '';
  const names = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
                 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
  const monthNum = m != null && m !== '' ? parseInt(m, 10) : NaN;
  const monthName = !isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 ? names[monthNum - 1] : '';
  const dayNum = day != null && day !== '' ? parseInt(day, 10) : NaN;
  if (!monthName) return `${y} г.`;
  if (isNaN(dayNum) || dayNum < 1) return `${monthName} ${y} г.`;
  return `${dayNum} ${monthName} ${y} г.`;
};

export const getLocalizedText = (
  key: string,
  lang: 'ru' | 'en',
  translations: Record<string, Record<string, string>>
): string => {
  const localeKey = lang === 'ru' ? 'ru-RU' : 'en-US';
  return translations[localeKey]?.[key] || key;
};

export interface AppliedTemplate extends Template {
  colors: Template['colors'];
  fonts: Template['fonts'];
}

export const applyOverrides = (template: Template, overrides: UserOverrides): AppliedTemplate => ({
  ...template,
  colors: { ...template.colors, ...overrides.colors },
  fonts: {
    ...template.fonts,
    baseFamily: overrides.fontFamily
      ? [overrides.fontFamily, ...template.fonts.baseFamily]
      : template.fonts.baseFamily,
    scale: overrides.fontSize
      ? { ...template.fonts.scale, base: overrides.fontSize }
      : template.fonts.scale,
  },
});

export const resolveAccentColor = (t: AppliedTemplate): string =>
  t.colors?.accent || t.colors?.secondary || '#ECECEC';

export const resolveBgColor = (t: AppliedTemplate): string =>
  t.colors?.bg || '#FFFFFF';
